
import React, { useState } from 'react';

const CreateQuote: React.FC = () => {
  const [tours, setTours] = useState<any[]>([]);

  return (
    <div className="p-8 space-y-8 max-w-7xl mx-auto w-full">
      <section className="bg-white dark:bg-slate-900 border border-slate-200 dark:border-slate-800 rounded-2xl p-6 shadow-sm">
        <div className="flex items-center gap-2 mb-6 border-b border-slate-100 dark:border-slate-800 pb-4">
          <span className="material-icons-round text-primary">settings</span>
          <h2 className="font-semibold text-slate-900 dark:text-white">Configuração da reserva ou cotação</h2>
        </div>
        <div className="grid grid-cols-1 md:grid-cols-3 gap-6">
          {[
            { label: 'Vendedor', options: ['Selecionar vendedor', 'Thiago Andrade', 'Ana Silva'] },
            { label: 'Moeda', options: ['CLP$ - Pesos chilenos', 'USD - Dólar Americano', 'BRL - Real Brasileiro'] },
            { label: 'Origem', options: ['Selecionar origem', 'Site', 'WhatsApp', 'Indicação'] },
          ].map(field => (
            <div key={field.label} className="space-y-1.5">
              <label className="text-xs font-semibold text-slate-500 dark:text-slate-400 px-1">{field.label}</label>
              <select className="w-full bg-slate-50 dark:bg-slate-800/50 border-slate-200 dark:border-slate-700 rounded-lg text-sm px-4 py-2.5 focus:ring-primary focus:border-primary">
                {field.options.map(opt => <option key={opt}>{opt}</option>)}
              </select>
            </div>
          ))}
        </div>
      </section>

      <section className="bg-white dark:bg-slate-900 border border-slate-200 dark:border-slate-800 rounded-2xl p-6 shadow-sm">
        <div className="flex items-center gap-2 mb-6 border-b border-slate-100 dark:border-slate-800 pb-4">
          <span className="material-icons-round text-primary">person</span>
          <h2 className="font-semibold text-slate-900 dark:text-white">Informações do Cliente</h2>
        </div>
        <div className="grid grid-cols-1 md:grid-cols-2 gap-6">
          <div className="space-y-1.5">
            <label className="text-xs font-semibold text-slate-500 dark:text-slate-400 px-1">Nome completo</label>
            <input className="w-full bg-slate-50 dark:bg-slate-800/50 border-slate-200 dark:border-slate-700 rounded-lg text-sm px-4 py-2.5" placeholder="Ex: João Silva" type="text" />
          </div>
          <div className="space-y-1.5">
            <label className="text-xs font-semibold text-slate-500 dark:text-slate-400 px-1">ID / Passaporte</label>
            <input className="w-full bg-slate-50 dark:bg-slate-800/50 border-slate-200 dark:border-slate-700 rounded-lg text-sm px-4 py-2.5" placeholder="11.111.111-X" type="text" />
          </div>
          <div className="space-y-1.5">
            <label className="text-xs font-semibold text-slate-500 dark:text-slate-400 px-1">E-mail</label>
            <input className="w-full bg-slate-50 dark:bg-slate-800/50 border-slate-200 dark:border-slate-700 rounded-lg text-sm px-4 py-2.5" placeholder="joao@exemplo.com" type="email" />
          </div>
          <div className="space-y-1.5">
            <label className="text-xs font-semibold text-slate-500 dark:text-slate-400 px-1">Telefone</label>
            <input className="w-full bg-slate-50 dark:bg-slate-800/50 border-slate-200 dark:border-slate-700 rounded-lg text-sm px-4 py-2.5" placeholder="+56 9 1234 5678" type="tel" />
          </div>
        </div>
      </section>

      <section className="bg-white dark:bg-slate-900 border border-slate-200 dark:border-slate-800 rounded-2xl p-6 shadow-sm">
        <div className="flex items-center gap-2 mb-6 border-b border-slate-100 dark:border-slate-800 pb-4">
          <span className="material-icons-round text-primary">add_location_alt</span>
          <h2 className="font-semibold text-slate-900 dark:text-white">Adicionar Reserva de Tour</h2>
        </div>
        <div className="grid grid-cols-1 md:grid-cols-4 gap-6">
          <div className="space-y-1.5">
            <label className="text-xs font-semibold text-slate-500 dark:text-slate-400 px-1">Destino</label>
            <select className="w-full bg-slate-50 dark:bg-slate-800/50 border-slate-200 dark:border-slate-700 rounded-lg text-sm px-4 py-2.5">
              <option>Santiago</option>
              <option>San Pedro de Atacama</option>
              <option>Torres del Paine</option>
            </select>
          </div>
          <div className="space-y-1.5">
            <label className="text-xs font-semibold text-slate-500 dark:text-slate-400 px-1">Tour</label>
            <select className="w-full bg-slate-50 dark:bg-slate-800/50 border-slate-200 dark:border-slate-700 rounded-lg text-sm px-4 py-2.5">
              <option>City Tour Santiago</option>
              <option>Valle Nevado</option>
              <option>Cajón del Maipo</option>
            </select>
          </div>
          <div className="space-y-1.5">
            <label className="text-xs font-semibold text-slate-500 dark:text-slate-400 px-1">Data</label>
            <input className="w-full bg-slate-50 dark:bg-slate-800/50 border-slate-200 dark:border-slate-700 rounded-lg text-sm px-4 py-2.5" type="date" />
          </div>
          <div className="space-y-1.5">
            <label className="text-xs font-semibold text-slate-500 dark:text-slate-400 px-1">Adultos</label>
            <input className="w-full bg-slate-50 dark:bg-slate-800/50 border-slate-200 dark:border-slate-700 rounded-lg text-sm px-4 py-2.5" type="number" defaultValue={1} min={0} />
          </div>
        </div>
        <div className="mt-8 flex justify-end">
          <button className="bg-primary text-white px-6 py-2.5 rounded-lg font-semibold flex items-center gap-2 hover:bg-blue-600 transition-all shadow-lg shadow-blue-500/20 active:scale-95">
            <span className="material-icons-round">add</span>
            Adicionar Tour
          </button>
        </div>
      </section>

      <section className="bg-white dark:bg-slate-900 border border-slate-200 dark:border-slate-800 rounded-2xl p-6 shadow-sm">
        <div className="flex items-center justify-between mb-8">
          <div className="text-slate-900 dark:text-white font-bold text-xl">
            Subtotal: <span className="text-primary">CLP$ 0</span>
          </div>
          <div className="flex gap-4">
            <button className="px-6 py-3 border border-slate-200 dark:border-slate-700 text-slate-600 dark:text-slate-400 font-bold rounded-xl hover:bg-slate-50 dark:hover:bg-slate-800 transition-all">
              Limpar
            </button>
            <button className="bg-emerald-500 hover:bg-emerald-600 text-white font-bold py-3 px-8 rounded-xl shadow-lg shadow-emerald-500/20 transition-all flex items-center gap-2 active:scale-95">
              <span className="material-icons-round">save</span>
              Salvar Cotação
            </button>
          </div>
        </div>
      </section>
    </div>
  );
};

export default CreateQuote;
